"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var GraphQLClientRequestError = /** @class */ (function (_super) {
    tslib_1.__extends(GraphQLClientRequestError, _super);
    function GraphQLClientRequestError(request, response) {
        var _this = _super.call(this, "Request Error (Code: ".concat(response.status, "): ").concat(JSON.stringify({
            response: response,
            request: request,
        }))) || this;
        _this.statusCode = response.statusCode;
        _this.request = request;
        _this.response = response;
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(_this, GraphQLClientRequestError);
        }
        return _this;
    }
    return GraphQLClientRequestError;
}(Error));
exports.default = GraphQLClientRequestError;
//# sourceMappingURL=GraphQLClientRequestError.js.map